import {Component, inject, Input, OnChanges} from '@angular/core';
import {ObjectView} from '../../core/definitions/object-view';
import {ObjectEditService} from '../../core/object-edit.service';
import {SectionsContainer} from '../../core/definitions/sections-container';
import {RefService} from '../../core/ref.service';
import {PrimusRouterService} from '../../core/primus-router.service';
import {ObjectTypes} from "../../core/definitions/object-types";
import {RefParams} from "../../core/definitions/ref-params";
import {RefData} from "../../core/definitions/ref-data";

@Component({
    selector: 'app-object-view-tabbed-sections',
    templateUrl: './object-view-tabbed-sections.component.html',
    styleUrls: ['./object-view-tabbed-sections.component.scss'],
    standalone: false
})
export class ObjectViewTabbedSectionsComponent implements OnChanges {
  // Injections
  private readonly primusRouter: PrimusRouterService = inject(PrimusRouterService);
  private readonly objectEditService: ObjectEditService = inject(ObjectEditService);
  private readonly refService: RefService = inject(RefService);

  @Input() objectId: string;
  @Input() folderId: string;
  @Input() templateGroupId: string;

  objectViewData: ObjectView;
  sectionsContainer: SectionsContainer;

  ngOnChanges(): void {
    this.setObjectViewData().then();
  }

  private async setObjectViewData() {
    this.sectionsContainer = await this.objectEditService.loadObjectGetSectionsContainer(this.objectId, false, this.templateGroupId);
    this.objectViewData = this.sectionsContainer.objectView;
  }

  private async createRef(searchItem): Promise<RefData> {
    const params = new RefParams(searchItem);
    params.rootObjId = this.folderId;
    params.rootObjType = ObjectTypes.FOLDER;
    return await this.refService.makeRef(params);
  }

  async goToObjectState(item) {
    const refInfo = await this.createRef(item);
    await this.primusRouter.navigateState(refInfo.stateName, refInfo.param);
  }
}
